
/**
 * Created by puxiaojian on 2018/12/26
 */
import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const queryworkOrderBiz = new Logic()

queryworkOrderBiz.findOrderByPage = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.findOrderByPage,
    data: data
  })
}

queryworkOrderBiz.getTaskDetailById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.getTaskDetailById,
    data: data
  })
}

queryworkOrderBiz.execute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.execute,
    data: data
  })
}

queryworkOrderBiz.paasApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.paasApproveApply,
    data: data
  })
}

queryworkOrderBiz.paasExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.paasExecute,
    data: data
  })
}

queryworkOrderBiz.shutdownApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.shutdownApproveApply,
    data: data
  })
}

queryworkOrderBiz.shutdownExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.shutdownExecute,
    data: data
  })
}

queryworkOrderBiz.approveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.approveApply,
    data: data
  })
}

queryworkOrderBiz.businessApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.businessApproveApply,
    data: data
  })
}

queryworkOrderBiz.businessExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.businessExecute,
    data: data
  })
}

queryworkOrderBiz.commonApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.commonApproveApply,
    data: data
  })
}

queryworkOrderBiz.commonExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.commonExecute,
    data: data
  })
}

queryworkOrderBiz.permissionApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.permissionApproveApply,
    data: data
  })
}

queryworkOrderBiz.permissionExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.permissionExecute,
    data: data
  })
}

queryworkOrderBiz.closeApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.closeApproveApply,
    data: data
  })
}

queryworkOrderBiz.closeExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.closeExecute,
    data: data
  })
}

queryworkOrderBiz.revokeApproveApply = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.revokeApproveApply,
    data: data
  })
}

queryworkOrderBiz.revokeExecute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.resApplication.revokeExecute,
    data: data
  })
}

/**
 * Created by xiehan on 2019/02/21.
 * 导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
queryworkOrderBiz.exportOrder = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.resApplication.findOrderByPage,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    isJson: 0
  })
  exportTable.send(success, fail)
}

export default queryworkOrderBiz
